import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from './guards/auth.guard'
import { ProtectAccessGuard } from './guards/protect-access.guard'
import { SimpleLoadingStrategy } from './Models/Classes/LoadStrategy/simple-loading-strategy'
import { PagoVerificacionComponent } from './components/pago-verificacion/pago-verificacion.component'
import { ChimeContactComponent } from './chime-contact/meeting/chime-contact.component'

const route = 'loader';

const routes: Routes = [
  {
    path: 'jubilados/registro',
    loadChildren: () => import('./pages/jubilados-form/jubilados-form.module').then(m => m.JubiladosFormPageModule),
  },
  {
    path: '',
    redirectTo: route,
    pathMatch: 'full',
  },
   { path: 'inline-bowsing', loadChildren: () => import('./lazy-routes/general-feature-routes.module').then(m => m.InlineBrowsingRouteModule) },
   { path: 'recarga-stripe', loadChildren: () => import('./lazy-routes/recarga-stripe-route.module').then(m => m.RecargaStripeRouteModule) },
   { path: 'alibaba-checkout-cart', loadChildren: () => import('./lazy-routes/general-feature-routes.module').then(m => m.AlibabaCheckoutRouteModule) },
   { path: 'apple-tv', loadChildren: () => import('./qr-code-generator/qr-code-generator.module').then(m => m.QrCodeGeneratorModule) },

  {
    path: 'profile/:profile_id',
    loadChildren: () =>
      import('./pages/profile/profile.module').then(
        (m) => m.ProfilePageModule,
      ),
    data: {
      preload: true,
    },
  },
  {
    path: 'profile/:profile_id/:username',
    loadChildren: () =>
      import('./pages/profile/profile.module').then(
        (m) => m.ProfilePageModule,
      ),
    data: {
      preload: true,
    },
  },
  {
    path: 'explora/:country/:city',
    loadChildren: () =>
      import('./pages/explore-mexico/explore-mexico.module').then(
        (m) => m.ExploreMexicoPageModule,
      ),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/principal/home/home.module').then(
        (m) => m.HomePageModule,
      ),
    data: {
      preload: true,
    },
    //canActivate: [ProtectAccessGuard],
  },
  {
    path: 'lia-collabs',
    loadChildren: () =>
      import('./pages/lia-collabs/lia-collabs.module').then(
        (m) => m.LiaCollabsPageModule,
      ),
  },
  {
    path: 'mycelium',
    loadChildren: () =>
      import('./pages/mycelium/mycelium.module').then(
        (m) => m.MyceliumPageModule,
      ),
  },
  {
    path: 'my-feed',
    loadChildren: () =>
      import('./pages/my-feed-page/my-feed-page.module').then(
        (m) => m.MyFeedPagePageModule,
      ),
    data: {
      preload: true,
    },
  },
  {
    path: 'p/:query',
    redirectTo: 'home/ecosystem-page/:query',
    pathMatch: 'full',
  },
  {
    path: 'search',
    loadChildren: () =>
      import('../app/pages/search-page/search-page.module').then(
        (m) => m.SearchPagePageModule,
      ),
    data: {
      preload: true,
    },
  },
 
  {
    path: 'login',
    redirectTo: 'login/null',
    pathMatch: 'full',
  },
  {
    path: 'login/:query',
    loadChildren: () =>
      import('./pages/principal/auth/login/login.module').then(
        (m) => m.LoginPageModule,
      ),
   // canActivate: [AuthGuard],
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./pages/principal/auth/register/register.module').then(
        (m) => m.RegisterPageModule,
      ),
    //canActivate: [AuthGuard],
  },
  {
    path: 'waiting-page',
    loadChildren: () =>
      import('./pages/principal/start/waiting-page/waiting-page.module').then(
        (m) => m.WaitingPagePageModule,
      ),
  },
  {
    path: 'wix-laniakea-publisher',
    loadChildren: () =>
      import('./pages/wix-laniakea-publisher/wix-laniakea-publisher.module').then(
        (m) => m.WixLaniakeaPublisherPageModule,
      ),
  },
  {
    path: 'verification',
    loadChildren: () =>
      import('./pages/principal/auth/verification/verification.module').then(
        (m) => m.VerificationPageModule,
      ),
   // canActivate: [AuthGuard],
  },
  {
    path: 'welcome-message',
    loadChildren: () =>
      import('./components/general-design/welcome-message/welcome-message.module').then(
        (m) => m.WelcomeMessagePageModule,
      ),
  },
  {
    path: 'pago-verificacion',
    component: PagoVerificacionComponent,
  },
  {
    path: 'chime-contact',
    component: ChimeContactComponent,
  },
  {
    path: 'calls/active/:callUUID',
    component: ChimeContactComponent,
  },
    {
    path: 'StockKeepingUnit',
    loadChildren: () => import('./lazy-routes/general-feature-routes.module').then(m => m.StockKeepingUnitRouteModule)
   // canActivate: [AuthGuard],
  },
  {
    path: 'publication-feed',
    loadChildren: () =>
      import('./pages/publication-feed/publication-feed.module').then(
        (m) => m.PublicationFeedPageModule,
      ),
  },
  {
    path: 'create-publication',
    loadChildren: () =>
      import('./pages/create-publication/create-publication.module').then(
        (m) => m.CreatePublicationPageModule,
      ),
  },
  {
    path: 'chat-page',
    loadChildren: () => import('./pages/chat/chat-page/chat-page.module').then( m => m.ChatPagePageModule)
  },

  {
    path: 'land-servicios-view',
    loadChildren: () => import('./pages/ecosistemas/land-servicios/land-servicios-view/land-servicios-view.module').then( m => m.LandServiciosViewPageModule)
  },
  {
    path: 'eventos-eclipse-view',
    loadChildren: () => import('./pages/ecosistemas/Eventos-Eclipse/eventos-eclipse-view/eventos-eclipse-view.module').then( m => m.EventosEclipseViewPageModule)
  },
    {
      path: 'lk-music',
      loadChildren: () => import('./lazy-routes/general-feature-routes.module').then(m => m.LkMusicRouteModule)
    },
    {
      path: 'shazam',
      loadChildren: () => import('./lazy-routes/general-feature-routes.module').then(m => m.ShazamRouteModule)
    },
    {
      path: 'lk-film-studios',
      loadChildren: () => import('./lazy-routes/general-feature-routes.module').then(m => m.LkFilmStudiosRouteModule)
    },
  {
    path: 'educacion-epoch-view',
    loadChildren: () => import('./pages/ecosistemas/Educacion-Epoch/educacion-epoch-view/educacion-epoch-view.module').then( m => m.EducacionEpochViewPageModule)
  },
  {
    path: 'hospedaje-earth-view',
    loadChildren: () => import('./pages/ecosistemas/Hospedaje-Earth/hospedaje-earth-view/hospedaje-earth-view.module').then( m => m.HospedajeEarthViewPageModule)
  },
  {
    path: 'earth',
    loadChildren: () => import('./pages/ecosistemas/Hospedaje-Earth/hospedaje-earth-view/hospedaje-earth-view.module').then( m => m.HospedajeEarthViewPageModule)
  },
  {
    path: 'terminos-condiciones-view',
    loadChildren: () => import('./pages/Terminos-Condiciones/terminos-condiciones-view/terminos-condiciones-view.module').then( m => m.TerminosCondicionesViewPageModule)
  },
  {
    path: 'chat-page',
    loadChildren: () => import('./pages/chat/chat-page/chat-page.module').then( m => m.ChatPagePageModule)
  },
  {
    path: 'loader',
    pathMatch: 'full' ,
    loadChildren: () => import('./pages/loader/loader.module').then( m => m.LoaderPageModule),
   
  },
  {
    path: 'publication-save',
    loadChildren: () => import('./pages/save-publication/publication-save/publication-save.module').then( m => m.PublicationSavePageModule)
  },
  {
    path: 'messages-page',
    loadChildren: () => import('./pages/messages-page/messages-page.module').then( m => m.MessagesPagePageModule),
    data: {
      preload: true,
    },
  },
  {
    path: 'admin/jarvis-email-inbox',
    loadChildren: () => import('./pages/jarvis-email-inbox/jarvis-email-inbox.module').then(m => m.JarvisEmailInboxPageModule),
  },
  {
    path: 'notifications-page',
    loadChildren: () => import('./pages/notifications-page/notifications-page.module').then( m => m.NotificationsPagePageModule)
  },
  {
    path: 'voice-notes',
    loadChildren: () => import('./voice-notes/voice-notes.module').then( m => m.VoiceNotesPageModule)
  },
  {
    path: 'dropship-product-selection',
    redirectTo: 'feex-wholesale/null',
    pathMatch: 'full',
  },
  {
    path: 'feex-wholesale',
    redirectTo: 'feex-wholesale/null',
    pathMatch: 'full',
  },
  {
    path: 'feex',
    redirectTo: 'feex-wholesale/null',
    pathMatch: 'full',
  },
  {
    path: 'feex/:query',
    redirectTo: 'feex-wholesale/:query',
    pathMatch: 'full',
  },

  {
    path: 'feex-wholesale/:query',
    loadChildren: () => import('./dropship-product-selection/dropship-product-selection.module').then( m => m.DropshipProductSelectionPageModule),
    data: {
      preload: true,
    },
  },

  {
    path: 'feex-wholesale-purchase',
    loadChildren: () => import('./lazy-routes/general-feature-routes.module').then(m => m.FeexPurchasesRouteModule)
  },

  {
    path: 'email-fga',
    pathMatch: 'full',
    loadChildren: () => import('./pages/email-fga/email-fga.module').then(m => m.EmailFgaPageModule)
  },
  {
    path: 'email-fga/:message',
    loadChildren: () => import('./pages/email-fga/email-fga.module').then(m => m.EmailFgaPageModule)
  },

  // Keep this last for native apps, local development, and non-Firebase hosts.
  // Firebase Hosting sends paths outside the known Angular route prefixes
  // through its lightweight Wix bridge before loading the Angular shell.
  {
    path: '**',
    loadChildren: () => import('./pages/wix-route-fallback/wix-route-fallback.module').then(m => m.WixRouteFallbackPageModule)
  },






]

@NgModule({
  providers: [SimpleLoadingStrategy],
  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', preloadingStrategy: SimpleLoadingStrategy }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
